import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class Portal extends React.Component {
    static propTypes = {
        /** Contents of the portal */
        children: PropTypes.node.isRequired,

        /** The type of html element you want the portal to be */
        tag: PropTypes.string,

        /** The id of the container the portal should be appended to.
         * If not provided, the portal will be appended directly to the <body> */
        rootId: PropTypes.string
    };

    static defaultProps = {
        tag: 'div',
        rootId: undefined
    };

    constructor(props) {
        super(props);

        if (props.rootId) {
            this.parent = document.getElementById(props.rootId);
        }
        else {
            this.parent = document.body;
        }

        this.el = document.createElement(props.tag);
        this.el.setAttribute('data-component', 'Portal');
    }

    componentDidMount() {
        this.parent.appendChild(this.el);
    }

    componentWillUnmount() {
        this.parent.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el
        );
    }
}